var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "link_round [#fffffffffff]"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-380.000000, -3279.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.238743,3120.76128 C339.890401,3118.41291 336.082738,3118.41291 333.734396,3120.76128 L331.165552,3123.33016 L332.582776,3124.7474 L335.15162,3122.17852 C336.718184,3120.61194 339.253953,3120.61194 340.821519,3122.17852 C342.384074,3123.7421 342.384074,3126.28491 340.821519,3127.84849 L338.252675,3130.41737 L339.669899,3131.83461 L342.238743,3129.26573 C344.587086,3126.91736 344.587086,3123.10965 342.238743,3120.76128 L342.238743,3120.76128 Z M332.84838,3135.82073 C332.091659,3136.57846 331.084367,3136.99541 330.013932,3136.99541 C328.943496,3136.99541 327.936205,3136.57846 327.179483,3135.82073 C325.615926,3134.25815 325.615926,3131.71433 327.179483,3130.15176 L329.748327,3127.58288 L328.330101,3126.16464 L325.761257,3128.73352 C323.412914,3131.08189 323.412914,3134.8896 325.761257,3137.23897 C326.935929,3138.41266 328.474429,3139 330.013932,3139 C331.553434,3139 333.091934,3138.41266 334.266607,3137.23897 L336.835451,3134.6701 L335.417224,3133.25185 L332.84838,3135.82073 Z M336.263149,3125.31971 L337.680373,3126.73695 L331.721817,3132.69558 L330.304593,3131.27834 L336.263149,3125.31971 Z",
    id: "link_round-[#fffffffffff]"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fcdd7e24df4119746581cfc6f603bc81.svg";
export { ForwardRef as ReactComponent };